<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { useFeaturesStore } from '@/shared/store'
  import { TravelDirection } from '@/shared/types/common.types'
  import { computed, defineAsyncComponent } from 'vue'

  const FlowContactsWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowContactsWidget/FlowContactsWidget.vue')
  )
  const FlowContactsWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowContactsWidgetQC/FlowContactsWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  const isContactsQcEnabled = computed(() => featuresStore.isContactsQcEnabled)
  useApiRequestsAbort()
</script>

<template>
  <FlowContactsWidgetQC v-if="isContactsQcEnabled" :type-of-travel="TravelDirection.INBOUND" />
  <FlowContactsWidget v-else :type-of-travel="TravelDirection.INBOUND" />
</template>
